import axios from "axios";
import store from "@/store/index";

const API = axios.create({
  baseURL:
    // (process.env.NODE_ENV == "development" ?  "http://127.0.0.1:11101" : "") + "/api/v1/",
    "/api/v1/"
});

API.interceptors.response.use(
  function(response) {
    if (response.data.error) {
      if (
        response.data.error_class === "TokenExpired" ||
        response.data.error_class === "InvalidToken"
      ) {
        store.dispatch("logout");
      }

      if (response.data.error_class === "AccessException") {
        store.commit("setAccessAvailability", false);
      }

      throw new Error(response.data.error_message);
    }

    return response;
  },
  function(error) {
    throw new Error(error.response.data.error_message);
  }
);

export default API;
